import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-add-language',
  templateUrl: './add-language.component.html',
  styleUrls: ['./add-language.component.less']
})
export class AddLanguageComponent implements OnInit {

  dropdownLabel = 'Select';
  selectedTranslator: number;

  @Input() addLang: boolean;
  @Input() listTranslators: any[];
  @Output() addLangChange = new EventEmitter<boolean>();
  @Output() translatorId = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {
    
  }

  close() {
    this.addLangChange.emit(false);
  }

  assign() {
    this.translatorId.emit(this.selectedTranslator);
    this.addLangChange.emit(false);
  }

  changeTranslator(e) {
    this.selectedTranslator = e.id;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/questions-tab/add-language/add-language.component.ts